import React from 'react';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '@/config/app';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-weak-50 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <i className="ri-error-warning-line text-6xl text-text-soft-400 mb-4 block"></i>
          <h1 className="text-4xl font-bold text-text-strong-950 mb-2">404</h1>
          <h2 className="text-2xl font-semibold text-text-sub-600 mb-4">
            Page Not Found
          </h2>
          <p className="text-text-sub-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to={APP_CONFIG.homeRoute}
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-static-white bg-primary bg-primary-hover focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors"
          >
            <i className="ri-home-line text-[20px] mr-2"></i>
            Go to deliveries
          </Link>

          <div>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-6 py-3 border border-stroke-sub-300 text-base font-medium rounded-md text-text-sub-600 bg-bg-white-0 hover:bg-bg-weak-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors"
            >
              <i className="ri-arrow-left-line text-[20px] mr-2"></i>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
